import script from "./OrderMonitoring.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderMonitoring.vue?vue&type=script&setup=true&lang=js"

import "./OrderMonitoring.vue?vue&type=style&index=0&id=b140f71e&lang=css"

const __exports__ = script;

export default __exports__